module.exports = {"370781001":"王府街道","370781002":"益都街道","370781006":"云门山街道","370781007":"黄楼街道","370781100":"弥河镇","370781101":"王坟镇","370781103":"庙子镇","370781105":"邵庄镇","370781109":"高柳镇","370781111":"何官镇","370781113":"东夏镇","370781115":"谭坊镇","370781400":"青州经济开发区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370781.json
// module id = 1419
// module chunks = 0